export default "__VITE_ASSET__Czw5TbcN__"